<template>
  <div class="resource">
    <div class="distributed-header">
      <div class="distributed-logo"></div>
      <span class="school">资源统计</span>
      <span class="word">Resource statistics</span>
      <div class="header-bottom"></div>
    </div>
    <div class="chart" ref="chart" id="myChart">
      <ul>
        <li v-for="(item, index) in line" :key="index">
          <div class="chart-top">
            <div>
              <i :style="{ backgroundImage: 'url(' + item.bg + ')' }"> </i
              ><span>{{ item.title }}</span>
            </div>
            <span>{{item.num}}</span>
          </div>
          <div class="chart-line">
            <div class="chart-line1" :style="{ width: item.width + '%' }"></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      line: [
        {
          title: "医疗站",
          width: 100,
          bg: require("./../../../assets/img/line1.png"),
          num: "1",
        },
        {
          title: "摄像头",
          width: 100,
          bg: require("./../../../assets/img/line2.png"),
          num: "158",
        },
        {
          title: "消防设备",
          width: 100,
          bg: require("./../../../assets/img/line3.png"),
          num: "673",
        },
        {
          title: "供电系统",
          width: 100,
          bg: require("./../../../assets/img/line4.png"),
          num: "15",
        },
        {
          title: "志愿者服务站",
          width: 100,
          bg: require("./../../../assets/img/line5.png"),
          num: "6",
        },
        {
          title: "供气站",
          width: 100,
          bg: require("./../../../assets/img/line6.png"),
          num: "2",
        },
      ],
    };
  },
  created() {},
  mounted() {
    // this.draw();
  },
  methods: {},
};
</script>
<style scoped>
.resource {
  width: 100%;
  height: 100%;
  background: url("./../../../assets/img/resource-bg.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header {
  width: 100%;
  height: 13%;
  position: relative;
  box-sizing: border-box;
  padding-left: 0.05rem;
  display: flex;
}
.header-bottom {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 0.0125rem;
  background: url("./../../../assets/img/distributed-line.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header .distributed-logo {
  margin-top: 0.0625rem;
  width: 0.6375rem;
  background: url("./../../../assets/img/distributed-logo.png") no-repeat;
  background-size: 100% 100%;
}
.distributed-header .school {
  font-size: 0.225rem;
  font-family: "pmzd";
  display: flex;
  align-items: center;
  margin: 0 0.0625rem;
  background-image: -webkit-linear-gradient(bottom, #7db2ff, #ffffff);
  -webkit-background-clip: text;
  color: transparent;
}
.distributed-header .word {
  font-family: "SourceHanSansCN";
  color: #9cc3ff;
  font-size: 0.15rem;
  margin-top: 0.0875rem;
}
.chart {
  width: 100%;
  height: 85%;
  padding: 0 0.1125rem;
  box-sizing: border-box;
  font-family: "SourceHanSansCN";
  box-sizing: border-box;
  padding-top: 2%;
}
.chart ul {
  height: 100%;

  display: flex;
  justify-content: space-between;
  flex-flow: wrap;
}
.chart ul li {
  width: 48%;
  height: 24%;
  color: #9cc3ff;
  padding-bottom: 1%;
  font-size: 0.15rem;
  /* border-bottom: 1px dashed #758a91; */
}
.chart ul li:nth-child(6) {
  border-bottom: none;
}
.chart ul li .chart-top {
  height: 60%;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  white-space: nowrap;
}
.chart ul li .chart-top span{
  display: flex;
  align-items: center;
}
.chart ul li .chart-line {
  margin-top: 0.03rem;
  height: 28%;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
}
.chart ul li .chart-line .chart-line1 {
  width: 60%;
  height: 100%;
  background-image: linear-gradient(to right, #4f7adc, #81a6fe);
  position: relative;
}
.chart ul li .chart-line .chart-line1::after {
  content: "";
  display: block;
  position: absolute;
  right: -0.0375rem;
  width: 0.025rem;
  height: 100%;
  background-color: #bbd7ff;
}
.chart ul li .chart-top > div {
  display: flex;
}

.chart ul li .chart-top i {
  display: inline-block;
  height: 90%;
  width: 0.2875rem;

  margin-right: 0.0625rem;
}
.chart ul li .chart-top span {
}

.chart ul li:nth-child(1) i {
  background-size: 100% 100%;
}
.chart ul li:nth-child(2) i {
  background-size: 100% 100%;
}
.chart ul li:nth-child(3) i {
  width: 0.2rem;

  background-size: 100% 100%;
  margin-right: 0.15rem;
}
.chart ul li:nth-child(4) i {
  background-size: 100% 100%;
}
.chart ul li:nth-child(5) i {
  background-size: 100% 100%;
}
.chart ul li:nth-child(6) i {
  background-size: 100% 100%;
}
</style>